import { z } from 'zod'

export const Inv4015SearchParamsSchema = z.object({
  itemCode: z.string().optional(),
  lotNo: z.string().optional(),
  location: z.string().optional(),
})

export type Inv4015SearchParams = z.infer<typeof Inv4015SearchParamsSchema>

export const Inv4015PickItemSchema = z.object({
  documentId: z.number(),
  documentNumber: z.string(),
  location: z.string(),
  pickMethod: z.string(),
  pickedAt: z.coerce.date(),
  pickedQty: z.number(),
  workOrder: z.string().nullable(),
})

export type Inv4015PickItem = z.infer<typeof Inv4015PickItemSchema>

export const Inv4015ResultSchema = z.object({
  picks: z.array(Inv4015PickItemSchema),
})

export type Inv4015Result = z.infer<typeof Inv4015ResultSchema>
